var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "login-card"
  }, [_c("section", {
    staticClass: "login-card__left"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("登录账号")]), _c("section", {
    staticClass: "login-flag login-form"
  }, [_c("a-form", {
    attrs: {
      form: _vm.form,
      hideRequiredMark: true
    },
    on: {
      submit: _vm.handleSubmit
    }
  }, [_c("a-form-item", {
    attrs: {
      label: "邮箱地址"
    }
  }, [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["email", {
        rules: [{
          required: true,
          message: "请输入工作邮箱!"
        }, {
          message: "请输入正确的邮箱格式!",
          type: "email",
          pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        }],
        validateTrigger: "blur"
      }],
      expression: "[\n              'email',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '请输入工作邮箱!',\n                  },\n                  {\n                    message: '请输入正确的邮箱格式!',\n                    type: 'email',\n                    pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$/,\n                  },\n                ],\n                validateTrigger: 'blur',\n              },\n            ]"
    }],
    attrs: {
      placeholder: "请输入工作邮箱",
      size: "large"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: "验证码"
    }
  }, [_c("a-input", {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ["code", {
        rules: [{
          required: true,
          message: "请输入邮箱验证码!"
        }]
      }],
      expression: "[\n              'code',\n              {\n                rules: [{ required: true, message: '请输入邮箱验证码!' }],\n              },\n            ]"
    }],
    attrs: {
      placeholder: "请输入邮箱验证码",
      size: "large"
    }
  }, [_c("template", {
    slot: "suffix"
  }, [_c("Captcha", {
    ref: "captcha",
    on: {
      send: _vm.handleSendCaptcha
    }
  })], 1)], 2)], 1), _c("a-form-item", [_c("button", {
    staticClass: "custom-btn login-btn",
    attrs: {
      type: "submit"
    }
  }, [_vm._v("登 录")])])], 1)], 1), _c("section", {
    staticClass: "bottom"
  }, [_c("a-popover", {
    attrs: {
      title: "邮箱无法获取验证码",
      overlayStyle: {
        width: "265px"
      }
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("p", [_vm._v("1. 请到邮箱垃圾桶里确认验证码是否被拦截；")]), _c("p", [_vm._v("2. 如需更换邮箱，请联系同花顺销售同事进行处理")])]), _c("span", [_vm._v("无法接收验证码?")])], 2), _c("div", {
    staticClass: "register"
  }, [_c("span", [_vm._v("没有账号？")]), _c("span", {
    on: {
      click: _vm.goRegister
    }
  }, [_vm._v("立即注册")])])], 1)]), _c("section", {
    staticClass: "login-card__right"
  }, [_c("LoginService", {
    attrs: {
      title: "完成注册并登录账户"
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };